import type { CutoverAction, CutoverStatus } from './cutover.types';

export const formatSeconds = (seconds: number): string => {
  const minutes = Math.max(0, Math.floor(seconds / 60));
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
};

export const formatTime = (iso: string): string =>
  new Date(iso).toLocaleString();

// What keeps the next step from starting without an override: the health
// checks that failed or could not run. A check that is not configured blocks
// nothing. The service decides; the page reads the same status to offer the
// override up front
export const overrideBlockers = (status: CutoverStatus): string[] =>
  status.health_checks
    .filter(
      (check) => check.status === 'failed' || check.status === 'cannot_run'
    )
    .map((check) =>
      check.status === 'cannot_run'
        ? `The health check ${check.name} could not run.`
        : `The health check ${check.name} is failing.`
    );

export const describeAction = (action: CutoverAction): string => {
  switch (action.action) {
    case 'ramp':
      return `Move to ${action.step_label}`;
    case 'reverse_step':
      return `Move ${action.step_label} back`;
    case 'reverse_user':
      return `Move user ${action.target_user_id} back`;
    case 'reverse_all':
      return 'Move everyone back';
  }
};

export const describeProgress = (action: CutoverAction): string =>
  action.planned === null
    ? 'Planning which users to move'
    : `Moved ${action.moved} of ${action.planned} users, ${action.failed} failed`;
